import { render, staticRenderFns } from "./DirectoriesPage.vue?vue&type=template&id=60f71420&"
import script from "./DirectoriesPage.vue?vue&type=script&lang=js&"
export * from "./DirectoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports